/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'glyph/24/calendar-date-2': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<g _fill="#fff" class="nc-icon-wrapper"><path pid="0" data-color="color-2" d="M19 1a1 1 0 00-2 0v2h2V1zM7 1a1 1 0 00-2 0v2h2V1z"/><path pid="1" d="M21 4H3a3 3 0 00-3 3v13a3 3 0 003 3h18a3 3 0 003-3V7a3 3 0 00-3-3zm1 16a1 1 0 01-1 1H3a1 1 0 01-1-1V9h20v11z"/><rect pid="2" data-color="color-2" x="4" y="11" width="4" height="3" rx=".5" ry=".5"/><rect pid="3" data-color="color-2" x="10" y="11" width="4" height="3" rx=".5" ry=".5"/><rect pid="4" data-color="color-2" x="4" y="16" width="4" height="3" rx=".5" ry=".5"/><rect pid="5" data-color="color-2" x="10" y="16" width="4" height="3" rx=".5" ry=".5"/><rect pid="6" data-color="color-2" x="16" y="11" width="4" height="3" rx=".5" ry=".5"/></g>'
  }
})
